import { Empty } from "antd";
export const Strings = {
  noData: "No data",
  ok: "Okay",
  na: "N/A",
};

export const NOTIFICATION_TYPES = {
  order_status: "order_status",
  earning_from_order: "earning_from_order",
  request_withdrawal: "request_withdrawal",
  sales_report: "sales_report",
  stock_details: "stock_details",
  new_product: "new_product",
  best_selling_product: "best_selling_product",
};

export const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
export const videoExtensions = ["mp4", "avi", "mov", "webm"];

export const EmptyData = () => <Empty key="empty" />;

export const categoryList = [
  {
    id: 15,
    name: "Plant-Based",
  },
  {
    id: 12,
    name: "Soy-Free",
  },
  {
    id: 3,
    name: "Organic",
  },
  {
    id: 4,
    name: "Non-GMO",
  },
  {
    id: 14,
    name: "Whole Grain",
  },
];
